import { Table } from "flowbite-react";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import { formatToReal } from "../../../utils/utils";

const FaturamentoPresumido = ({ data }) => {
  return (
    <>
      <TitleStripe>Faturamento Presumido</TitleStripe>
      {!data?.ErrorMessage ? (
        <div className="grid grid-cols-1 gap-2">
          <div className="flex items-center gap-2">
            <div className="font-semibold">Faixa de faturamento:</div>
            <div className="capitalize">{data?.IncomeRange}</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="font-semibold">Porte da empresa:</div>
            <div>{data?.CompanyPort}</div>
          </div>
          <div className="flex items-center gap-2">
            <div className="font-semibold">Faturamento presumido:</div>
            <div className="capitalize">{data?.PresumedRevenuePJ}</div>
          </div>
        </div>
      ) : (
        <div>{data?.ErrorMessage}</div>
      )}
    </>
  );
};

export default FaturamentoPresumido;
